export default __webpack_public_path__ + "static/media/14_gallery.35f7be2d.jpg";